import React from "react";
import { Col, Row } from "react-bootstrap";
import "../../styles/Blogs/LatestArticles.scss";
import { BiTimeFive } from "react-icons/bi";
import { AiOutlineEye } from "react-icons/ai";
import articlesPersonImage from "../../assets/images/articles-person-image.png";
import articlesImage from "../../assets/images/popular-articles-image.png";
import editorImage from "../../assets/images/blog-editor-image.png";
import latestArticleBg from "../../assets/images/blog-latest-article-bg.png";
import { Link } from "react-router-dom";

const LatestArticles = () => {
  return (
    <div className="latest-article-main-container container">
      <h1 className="blog-latest-article">Latest Articles</h1>
      <span>
        <img
          src={latestArticleBg}
          alt="container-bg"
          className="latest-article-category-image"
        />
      </span>
      <Row className="latest-article-section">
        <Col md={8}>
          <Link to="/blog-details" className="text-decoration-none">
            <Row className="blog-latest-article-section">
              <Col md={4}>
                <img
                  src={articlesImage}
                  alt="articleImage"
                  className="img-fluid h-100 w-100"
                />
              </Col>
              <Col md={8}>
                <div className="article-creator mt-3 mt-sm-3 mt-md-0">
                  <img
                    src={articlesPersonImage}
                    alt="img"
                    className="article-creator-image"
                  />
                  <div className="article-creator-section">
                    <h3 className="article-creator-name">
                      Md. Shafiqur Rahman Refat
                    </h3>
                    <h3 className="blog-article-date">25 Sept,2022</h3>
                  </div>
                </div>
                <div className="articles-details">
                  <h2 className="latest-blog-articles-title">
                    The Grid System: Importance of a Solid UX/UI Layout
                  </h2>
                  <p className="latest-blog-articles-description">
                    UX/UI and graphic designers have many things in common.
                    Among them is the practice of using grid layouts to
                    structure their designs{" "}
                  </p>
                  <div className="time-and-view d-flex">
                    <div className="blog-items-reading-time">
                      <span className="time-and-view-color">
                        <BiTimeFive />
                      </span>{" "}
                      6 min
                    </div>
                    <div className="blog-items-view">
                      <span className="time-and-view-color">
                        <AiOutlineEye />
                      </span>{" "}
                      1234
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Link>
          <Row className="blog-latest-article-section">
            <Col md={4}>
              <img
                src={articlesImage}
                alt="articleImage"
                className="img-fluid h-100 w-100"
              />
            </Col>
            <Col md={8}>
              <div className="article-creator mt-3 mt-sm-3 mt-md-0">
                <img
                  src={articlesPersonImage}
                  alt="img"
                  className="article-creator-image"
                />
                <div className="article-creator-section">
                  <h3 className="article-creator-name">Md. Shafiqur Rahman Refat</h3>
                  <h3 className="blog-article-date">25 Sept,2022</h3>
                </div>
              </div>
              <div className="articles-details">
                <h2 className="latest-blog-articles-title">
                  The Grid System: Importance of a Solid UX/UI Layout
                </h2>
                <p className="latest-blog-articles-description">
                  UX/UI and graphic designers have many things in common. Among
                  them is the practice of using grid layouts to structure their
                  designs{" "}
                </p>
                <div className="time-and-view d-flex">
                  <div className="blog-items-reading-time">
                    <span className="time-and-view-color">
                      <BiTimeFive />
                    </span>{" "}
                    6 min
                  </div>
                  <div className="blog-items-view">
                    <span className="time-and-view-color">
                      <AiOutlineEye />
                    </span>{" "}
                    1234
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="blog-latest-article-section">
            <Col md={4}>
              <img
                src={articlesImage}
                alt="articleImage"
                className="img-fluid h-100 w-100"
              />
            </Col>
            <Col md={8}>
              <div className="article-creator mt-3 mt-sm-3 mt-md-0">
                <img
                  src={articlesPersonImage}
                  alt="img"
                  className="article-creator-image"
                />
                <div className="article-creator-section">
                  <h3 className="article-creator-name">Md. Shafiqur Rahman Refat</h3>
                  <h3 className="blog-article-date">25 Sept,2022</h3>
                </div>
              </div>
              <div className="articles-details">
                <h2 className="latest-blog-articles-title">
                  The Grid System: Importance of a Solid UX/UI Layout
                </h2>
                <p className="latest-blog-articles-description">
                  UX/UI and graphic designers have many things in common. Among
                  them is the practice of using grid layouts to structure their
                  designs{" "}
                </p>
                <div className="time-and-view d-flex">
                  <div className="blog-items-reading-time">
                    <span className="time-and-view-color">
                      <BiTimeFive />
                    </span>{" "}
                    6 min
                  </div>
                  <div className="blog-items-view">
                    <span className="time-and-view-color">
                      <AiOutlineEye />
                    </span>{" "}
                    1234
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>

        <Col md={4}>
          <div className="category-container mx-0 mx-sm-0 mx-md-3">
            <div className="category-title">Category</div>
            <div className="category-items">
              <a href="#" className="category-item">
                Grow your readership
              </a>
              <a href="#" className="category-item">
                Grow your readership
              </a>
              <a href="#" className="category-item">
                Grow your readership
              </a>
              <a href="#" className="category-item">
                Grow your readership
              </a>
            </div>
          </div>
          <div className="editors-section">
            <div className="editors-title">Editors</div>
            <div className="editor-creator">
              <img src={editorImage} alt="img" className="editor-image" />
              <div className="editor-section">
                <h3 className="editor-name">Md. Shafiqur Rahman Refat</h3>
                <h3 className="editor-designation">Founder of XYZ </h3>
              </div>
            </div>
            <div className="editor-creator">
              <img src={editorImage} alt="img" className="editor-image" />
              <div className="editor-section">
                <h3 className="editor-name">Md. Shafiqur Rahman Refat</h3>
                <h3 className="editor-designation">Founder of XYZ </h3>
              </div>
            </div>
            <div className="editor-creator">
              <img src={editorImage} alt="img" className="editor-image" />
              <div className="editor-section">
                <h3 className="editor-name">Md. Shafiqur Rahman Refat</h3>
                <h3 className="editor-designation">Founder of XYZ </h3>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LatestArticles;
